const Title = ({ text }) => {
  return (
    <div className="text-5xl md:text-6xl lg:text-7xl font-dark font-extrabold mb-8 text-center">
      {text}
    </div>
  );
};
export default Title;